export default "fragment seoScoreFragment on SEOScoreType{\nlength\ncond\nvalue\nlevel\nscore\nnormal\n}\n"